// --------------------------------------------------------------------------
// tnew.js
// --------------------------------------------------------------------------

RN.tnew = function() {

  'use strict';

  function init() {
    $('#cartTable table:not(.medium), form[action="./payment.aspx"] #tnew-site-table-wrapper table:not(.medium)').first().each(function(){
        var fields = [];
        var tableRows = [];

        $(this).find('tr:first-of-type td').each(function(){
            fields.push($(this).text().replace(/[ \n]/g, ''));
        });

        $(this).find('tr:not(:first-of-type)').each(function(){
            var obj = {};
            var index = 0;
            $(this).find('td').each(function(){
                var colspan = parseInt($(this).attr('colspan'));
                var value = $(this).html().replace(/[\n]/g, '').replace(/  /g, '');
                if(value){
                    obj[colspan && 'title' || fields[index]] = value;
                }
                index += colspan || 1;
            })
            tableRows.push(obj);
        });

        var table = $('<table />').addClass('mobile-only').insertAfter(this);
        var bg = ['#dddddd', '#eeeeee'];
        tableRows.forEach(function(tableRow, index){
            Object.keys(tableRow).forEach(function(tableCell){
                if(tableRow[tableCell]){
                    var row = $('<tr />').appendTo(table);
                    row.css('background', bg[index % bg.length])
                    if(tableCell && tableCell !== 'title'){
                        $('<td />').html(tableCell).appendTo(row);
                    }
                    $('<td />').html(tableRow[tableCell]).attr('colspan', tableCell && tableCell !== 'title' ? 1 : 2).appendTo(row);
                }
            })
        }.bind(this))

        $(this).addClass('desktop-only');
    });

    $('.tnew-donate-control-field').each(function(){
        var wrap = $('<div />', {
            class: 'donate-filed'
        }).insertAfter(this);
        $('<p />', {
            html: '&dollar;'
        }).appendTo(wrap);
        $(this).appendTo(wrap);
    });
  }

  return {
    init: init
  };

}();